import { TierIiReportKind } from "generated-graphql/graphql";

/**
 * Default report kind filter for fulfillment views.
 * Used by both data grids (via defaultSearch) and stats components.
 */
export const FULFILLMENT_DEFAULT_REPORT_KIND = TierIiReportKind.Annual;
export const FULFILLMENT_DEFAULT_REPORT_KINDS = [TierIiReportKind.Annual];
